import ProductPriceComparision from './ProductPriceComparision'

export default ProductPriceComparision
